import React, { useState } from "react";
const BudgetListOverlay = ({
    overlay, 
    setOverlay,
    overlayDropDown,
    setOverlayDropDown,
    setActiveCard,
    schemeBudgetRef
}) => {
    const [activeKeys, setActiveKeys] = useState([]); // Initially open accordions
    const handleSubCardChange = (val1, val2, val3) => {
        setActiveCard((prev) => {
        let updated = [...prev];
        // Remove val2 and val3 if present
        updated = updated.filter(item => item !== val2 && item !== val3);
        // Add val1 if not already present
        if (!updated.includes(val1)) {
            updated.unshift(val1); // Add at the beginning
        }
        return updated;
        });
    }
    return (
        <>
            <div className={`overlay ${overlay ? "d-none" : null}  `}></div>

                <div
                    className={`overlayContent overflow-auto ${
                    overlay ? "left-100" : null
                    } `}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center ps-4">
                    <div className="fw-600 fs-16px d-flex align-items-center gap-2 ">
                        <i
                        className="icon-close_circle_fill fs-5 cursor-pointer"
                        onClick={() => setOverlay(true)}
                        ></i>
                        Budget
                    </div>

                    <div className="d-flex gap-2 align-items-center h-100 py-3 position-relative pe-4">
                        <span className="text-secondary-100">As on date (date)</span>
                        <i
                        className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
                        onClick={() => setOverlayDropDown((prev) => !prev)}
                        ></i>

                        <div
                        className={`position-absolute bg-prime-100 w-100 p-3 ${
                            !overlayDropDown ? "d-none" : "d-inline-block"
                        }`}
                        style={{ top: "100%", zIndex: "10" }}
                        >
                        <div className="d-flex flex-column gap-4">
                            <span className="d-flex align-items-center gap-2 cursor-pointer">
                            <i className="icon-picture_as_pdf"></i> Export PDF
                            </span>
                        </div>
                        </div>
                    </div>
                    </div>

                    <div className="px-4 py-3 d-flex flex-column gap-2">
                        {
                            schemeBudgetRef?.records?.length && schemeBudgetRef.records.map((record, idx) => (
                                <div className="bg-white border-Prime-100" key={idx}>
                                    <div className="row p-2 m-0">
                                    <div className="px-1 col-12">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Financial Year* :
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.financial_year}</p>
                                        </span>
                                    </div>

                                    <div className="col-4 px-1 mt-2">
                                        <span className="d-flex flex-column p-0 px-1">
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Budget Order No. :
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.budget_order_no}</p>
                                        </span>
                                    </div>
                                    <div className="col-4 px-1 mt-2">
                                        <span className="d-flex flex-column p-0 px-1">
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Budget Order Date. :
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.budget_order_date}</p>
                                        </span>
                                    </div>
                                    <div className="col-4 px-1 mt-2">
                                        <span className="d-flex flex-column p-0 px-1">
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Release Budget Date* :
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.budget}</p>
                                        </span>
                                    </div>
                                    </div>

                                    <div className="row m-0 p-2">
                                    <div className="col-4 px-1 ">
                                        <span className="d-flex flex-column p-0 px-1">
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Scheme Code* :
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.scheme_code}</p>
                                        </span>
                                    </div>
                                    <div className="col-8 px-1">
                                        <span className="d-flex flex-column p-0 px-1">
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Scheme Name
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.scheme_name}</p>
                                        </span>
                                    </div>
                                    </div>
                                    <div className="row m-0 p-2">
                                    <div className="px-1 col-4">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Sub Head Code* 
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.subhead_code}</p>
                                        </span>
                                    </div>
                                    <div className="px-1 col-8">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Sub Head* 
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.subhead_name}</p>
                                        </span>
                                    </div>
                                    </div>

                                    {record?.activities?.length > 0 && (
                                        record.activities.map((activity, activityIdx) => (
                                            <div className="row m-0 p-2" key={activityIdx}>
                                                <div className="px-1 col-4">
                                                <span
                                                    className="d-flex flex-column p-0 px-1"
                                                >
                                                    <label htmlFor="text" className="fs-12px text-prime-100">
                                                    Activity | sub-Activity
                                                    </label>
                                                    <p className="fs-14px border-bottom-only">{activity.activity} | {activity.subactivity}</p>
                                                </span>
                                                </div>
                                                <div className="px-1 col-4">
                                                <span className="d-flex flex-column p-0 px-1">
                                                    <label htmlFor="text" className="fs-12px text-prime-100">
                                                    Provisional* :
                                                    </label>
                                                    <p className="fs-14px border-bottom-only">{activity.provisional_budget}</p>
                                                </span>
                                                </div>
                                                <div className="px-1 col-4">
                                                <span className="d-flex flex-column p-0 px-1">
                                                    <label htmlFor="text" className="fs-12px text-prime-100">
                                                    Release* :
                                                    </label>
                                                    <p className="fs-14px border-bottom-only">{activity.budget}</p>
                                                </span>
                                                </div>
                                            </div>
                                        ))
                                    
                                    )}

                                    <div className="row m-0 p-2">
                                    <div className="px-1 col-4">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        style={{ background: "#E2F6ED" }}
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Provisional Budget* :
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.provisional_budget}</p>
                                        </span>
                                    </div>
                                    <div className="px-1 col-4">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        style={{ background: "#E2F6ED" }}
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            Release Budget*:
                                        </label>
                                        <p className="fs-14px border-bottom-only">{record.budget}</p>
                                        </span>
                                    </div>
                                    </div>

                                    <div className="row m-0 p-2">
                                    <div className="px-1 col-4">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            L2 Remark:
                                        </label>
                                        <p className="fs-14px border-bottom-only">&nbsp;{record.l2remarks}</p>
                                        </span>
                                        {
                                            Number(record.l2_status) === 1 ? 
                                            <div className="fs-12px text-success-100 px-1" style={{ background: "#F8F8F8" }}>
                                                Approved
                                            </div> : Number(record.l2_status) === 0 ? 
                                            <div className="fs-12px text-warning-100 px-1" style={{ background: "#F8F8F8" }}>
                                                Pending
                                            </div>  : <div className="fs-12px text-danger-100 px-1" style={{ background: "#F8F8F8" }}>
                                                Rejected
                                            </div> 
                                        }
                                    </div>
                                    <div className="px-1 col-4">
                                        <span
                                        className="d-flex flex-column p-0 px-1"
                                        >
                                        <label htmlFor="text" className="fs-12px text-prime-100">
                                            L3 Remark
                                        </label>
                                        <p className="fs-14px border-bottom-only">&nbsp;{record.l3remakrs}</p>
                                        </span>
                                        {
                                            Number(record.l3_status) === 1 ? 
                                            <div className="fs-12px text-success-100 px-1" style={{ background: "#F8F8F8" }}>
                                                Approved
                                            </div> : Number(record.l3_status) === 0 ? 
                                            <div className="fs-12px text-warning-100 px-1" style={{ background: "#F8F8F8" }}>
                                                Pending
                                            </div> : <div className="fs-12px text-danger-100 px-1" style={{ background: "#F8F8F8" }}>Rejected</div> 
                                        }
                                    </div>
                                    <div className="px-1 col-4 d-flex align-items-center">
                                        <i className="icon-picture_as_pdf fs-18px"></i>
                                    </div>
                                    </div>

                                    <div className="px-2 m-0 mt-1">
                                    <div className="border mb-2 mx-2"></div>

                                        <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                        {/* {
                                        (!activeCard.includes(`subhead_${record?.id}`)) ? 
                                        <button
                                            onClick={() => handleSubCardChange(`subhead_${record?.id}`, `activity_${record?.id}`, `subactivity_${record?.id}`)}
                                            className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                            activeCard.includes(`subhead_${record?.id}`) ? "bg-secondary-20" : "bg-white"
                                            } `}
                                        >
                                            {activeCard.includes(`subhead_${record?.id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                            <i className="icon-add_circle_outline"></i>
                                            )}
                                            Sub head
                                        </button>
                                        : <button
                                            className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                            activeCard.includes(`subhead_${record?.id}`) ? "bg-secondary-20" : "bg-white"
                                            } `}
                                        >
                                            {activeCard.includes(`subhead_${record?.id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                            <i className="icon-add_circle_outline"></i>
                                            )}
                                            Sub head
                                        </button>
                                        } */}
                                        
                                        
                                        {/* {
                                            (!activeCard.includes(`activity_${record?.id}`)) ? (<button
                                            onClick={() => handleSubCardChange(`activity_${record?.id}`, `subhead_${record?.id}`, `subactivity_${record?.id}`)}
                                            className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                                activeCard.includes(`activity_${record?.id}`) ? "bg-secondary-20" : "bg-white"
                                            } `}
                                            >
                                            {activeCard.includes(`activity_${record?.id}`) ? (
                                                <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                                <i className="icon-add_circle_outline"></i>
                                            )}
                                            Activity
                                            </button>)  : (<button
                                            className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                                activeCard.includes(`activity_${record?.id}`) ? "bg-secondary-20" : "bg-white"
                                            } `}
                                            >
                                            {activeCard.includes(`activity_${record?.id}`) ? (
                                                <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                                <i className="icon-add_circle_outline"></i>
                                            )}
                                            Activity
                                            </button>) 
                                        } */}
                                            
                                            {/* {
                                            (!activeCard.includes(`subactivity_${record?.id}`)) ? ( <button
                                            onClick={() => handleSubCardChange(`subactivity_${record?.id}`, `activity_${record?.id}`, `subhead_${record?.id}`)}
                                            className={` ${
                                                activeCard.includes(`subactivity_${record?.id}`) ? "bg-secondary-20" : "bg-white"
                                            } 
                                            border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                            >
                                            {activeCard.includes(`subactivity_${record?.id}`) ? (
                                                <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                                <i className="icon-add_circle_outline"></i>
                                            )}
                                            Sub-Activity
                                            </button>) :
                                            ( <button
                                            onClick={() => {setActiveCard(0); setCardClose(true)}}
                                            className={` ${
                                                activeCard.includes(`subactivity_${record?.id}`) ? "bg-secondary-20" : "bg-white"
                                            } 
                                            border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                            >
                                            {activeCard.includes(`subactivity_${record?.id}`) ? (
                                                <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                                <i className="icon-add_circle_outline"></i>
                                            )}
                                            Sub-Activity
                                            </button>)
                                            } */}
                                        
                                        
                                        </div>

                                        {/* {activeCard.includes(`subhead_${record?.id}`) && (
                                            <>
                                            <div className="border mx-2"></div>
                                            <div className="row p-2 text-start">
                                                <div className="col-5 d-flex flex-column">
                                                    <span className="fs-12px text-black-60"> Sub Head</span>
                                                
                                                </div>

                                                <div className="col d-flex flex-column">
                                                <span className="fs-12px text-black-60">
                                                    {" "}
                                                    Provisional
                                                </span>
                                                <span className="fs-14px fw-600">-</span>
                                                </div>

                                                <div className="col d-flex flex-column">
                                                <span className="fs-12px text-black-60">Released</span>
                                                <span className="fs-14px fw-600 ">-</span>
                                                </div>
                                            </div>
                                            </>
                                        )} */}
                                        {/* {activeCard.includes(`activity_${record?.id}`) && (
                                            <>
                                            <div className="border mx-2"></div>
                                            <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                                                <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                                <Accordion.Item
                                                    eventKey="10"
                                                    style={{ borderRadius: "0", border: "0" }}
                                                >
                                                    <Accordion.Header
                                                    onClick={() => toggleAccordion("10")}
                                                    >
                                                    <div className="w-100 d-flex justify-content-between">
                                                        <span>Subhead Name</span>
                                                        <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                        }}
                                                        >
                                                        {activeKeys.includes("10") ? "-" : "+"}
                                                        </span>
                                                    </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                    <div>
                                                        {
                                                        <div className="row my-1 p-0 mx-0">
                                                            <div className="row p-2 text-start">

                                                            <div className="col-5 d-flex flex-column">
                                                                <span className="fs-12px text-black-60">
                                                                {" "}
                                                                Activity
                                                                </span>
                                                                <span className="fs-14px fw-600">-</span>
                                                            </div>

                                                            <div className="col d-flex flex-column">
                                                                <span className="fs-12px text-black-60">
                                                                {" "}
                                                                Provisional
                                                                </span>
                                                                <span className="fs-14px fw-600">-</span>
                                                            </div>

                                                            <div className="col d-flex flex-column">
                                                                <span className="fs-12px text-black-60">
                                                                Released
                                                                </span>
                                                                <span className="fs-14px fw-600 ">-</span>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                </Accordion>
                                            </div>
                                            </>
                                        )}
                                        {activeCard.includes(`subactivity_${record?.id}`) && (
                                            <>
                                            <div className="border mx-2"></div>
                                            <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                                                <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                                <Accordion.Item
                                                    eventKey="11"
                                                    style={{ borderRadius: "0", border: "0" }}
                                                >
                                                    <Accordion.Header
                                                    onClick={() => toggleAccordion("11")}
                                                    >
                                                    <div className="w-100 d-flex justify-content-between">
                                                        <span>Subhead Name | Activity</span>
                                                        <span
                                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                        style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                        }}
                                                        >
                                                        {activeKeys.includes("11") ? "-" : "+"}
                                                        </span>
                                                    </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                    <div>
                                                        {
                                                        <div className="row my-1 p-0 mx-0">
                                                            <div className="row p-2 text-start">
                                                            <div className="col-5 d-flex flex-column">
                                                                <span className="fs-12px text-black-60">
                                                                {" "}
                                                                Sub-Activity
                                                                </span>
                                                                <span className="fs-14px fw-600">-</span>
                                                            </div>

                                                            <div className="col d-flex flex-column">
                                                                <span className="fs-12px text-black-60">
                                                                {" "}
                                                                Provisional
                                                                </span>
                                                                <span className="fs-14px fw-600">-</span>
                                                            </div>

                                                            <div className="col d-flex flex-column">
                                                                <span className="fs-12px text-black-60">
                                                                Released
                                                                </span>
                                                                <span className="fs-14px fw-600 ">-</span>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                </Accordion>
                                            </div>
                                            </>
                                        )} */}
                                    </div>
                                </div>
                            ))
                        }
                        
                    </div>

                    {/* =========================footer============= */}

                    {/* <div
                    className={`bg-success-100 position-absolute bottom-0 w-100 d-flex justify-content-between align-items-center p-2 m-0`}
                    >
                         <div className="d-flex justify-content-end m-0 w-100 pe-5">
                            <div className=" d-flex flex-column pe-5 text-white text-start">
                                <span className="fs-12px text-start">Total Provisional</span>
                                <span className="fs-14px">2,000,000,000.00</span>
                            </div>

                            <div className=" d-flex flex-column text-white text-start">
                                <span className="fs-12px">Total Release</span>
                                <span className="fs-14px">2,000,000,000.00</span>
                            </div>
                        </div> 
                    </div> */}
                </div>
        </>
    )
}

export default BudgetListOverlay;